<template>
  <nav class="navbar navbar-expand-lg navbar-absolute"
       :class="{'bg-white': showMenu, 'navbar-transparent': !showMenu}">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-toggle d-inline" :class="{toggled: $sidebar.showSidebar}">
          <button type="button"
                  class="navbar-toggler"
                  aria-label="Navbar toggle button"
                  @click="toggleSidebar">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <a class="navbar-brand" href="#pablo">XSS HUNTER | <small>{{routeName}}</small></a>
      </div>

      <transition name="collapse">
        <div class="collapse navbar-collapse show" v-show="showMenu">
          <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
            <div class="search-bar input-group">
            </div>
          </ul>
        </div>
      </transition>
      
      <!-- User info and logout in top right -->
      <div class="navbar-nav ml-auto" v-if="currentUser">
        <div class="nav-item dropdown" :class="{'show': showUserDropdown}">
          <a class="nav-link dropdown-toggle text-white" href="#" id="userDropdown" role="button" 
             @click.prevent="toggleUserDropdown" aria-haspopup="true" :aria-expanded="showUserDropdown">
            <i class="fa fa-user"></i> {{currentUser.email}}
          </a>
          <div class="dropdown-menu dropdown-menu-right" :class="{'show': showUserDropdown}">
            <h6 class="dropdown-header">{{currentUser.email}}</h6>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click.prevent="handleLogout">
              <i class="fa fa-sign-out-alt"></i> Logout
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
  import { Transition } from 'vue';
  import Modal from '@/components/Modal';
  import api_request from '@/libs/api.js';

  export default {
    components: {
      Transition,
      Modal
    },
    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      },
      isRTL() {
        return this.$rtl.isRTL;
      }
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchModalVisible: false,
        searchQuery: '',
        currentUser: null,
        showUserDropdown: false
      };
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications;
      },
      closeDropDown() {
        this.activeNotifications = false;
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      toggleUserDropdown() {
        this.showUserDropdown = !this.showUserDropdown;
      },
      async loadCurrentUser() {
        try {
          const result = await api_request.get_current_user();
          if (result.success) {
            this.currentUser = result.result;
          }
        } catch (error) {
          console.error('Failed to load current user:', error);
        }
      },
      async handleLogout() {
        try {
          this.showUserDropdown = false; // Close dropdown
          
          // Show loading state
          if (window.app) {
            window.app.loading = true;
          }
          
          const result = await api_request.logout();
          
          // Clear user data first
          this.currentUser = null;
          if (window.app) {
            window.app.is_authed = false;
            window.app.loading = false;
          }
          
          if (result.success) {
            // Successful logout - redirect to root
            window.location.replace('/');
          } else {
            // API returned failure but session might still be cleared
            console.warn('Logout API returned failure, forcing frontend logout');
            window.location.replace('/');
          }
        } catch (error) {
          console.error('Logout failed:', error);
          
          // Clear loading state
          if (window.app) {
            window.app.loading = false;
          }
          
          // Even if API call fails, force logout on frontend
          this.currentUser = null;
          if (window.app) {
            window.app.is_authed = false;
          }
          
          // Use a small delay to ensure state is updated before redirect
          setTimeout(() => {
            window.location.replace('/');
          }, 100);
        }
      }
    },
    async mounted() {
      await this.loadCurrentUser();
      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('#userDropdown') && !e.target.closest('.dropdown-menu')) {
          this.showUserDropdown = false;
        }
      });
    }
  };
</script>
<style scoped>
.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  right: 0;
  left: auto;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #2c2c54;
  background-clip: padding-box;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.25rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  color: #ffffff;
  font-weight: 600;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  font-size: 0.75rem;
  text-transform: uppercase;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  clear: both;
  font-weight: 400;
  color: #ffffff;
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  transition: all 0.3s ease;
}

.dropdown-item:hover,
.dropdown-item:focus {
  background-color: #e14eca;
  color: #ffffff;
  text-decoration: none;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-link {
  cursor: pointer;
  user-select: none;
}

.dropdown-toggle::after {
  margin-left: 0.5rem;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
</style>
